export default "__VITE_ASSET__1468f348__"